import React from 'react';
import { Reveal, Stagger, StaggerItem } from './Reveal';

export const PainPointsSection = () => {
  const quotes = [
    "I eat so little, but I still gain weight",
    "Mera chehra pura pimples se bhar gaya",
    "Mala pet fugane and gas cha kup problem ahe",
    "By afternoon, my energy crashes.",
    "I have PCOS and I don't know what to eat",
    "Mere paas khana banane ka time nahi hota",
    "Mala asa plan hava jo mi follow karu shakte",
    "Everything I like is unhealthy.",
    "I feel hungry soon after eating"
  ];

  return (
    <section
      className="section-padding grain-texture"
      style={{ background: 'var(--brand-pale-sage)' }}>

      <div className="container-custom">
        <Reveal className="max-w-4xl mx-auto text-center mb-20">
          <h2 className="heading-1 text-balance">
            Different bodies. Different languages. Same frustration.
          </h2>
          <p className="body-large mt-8" style={{ color: 'var(--brand-muted-grey)' }}>
            We hear you. These are real struggles from real people.
          </p>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {quotes.map((quote, index) => (
            <StaggerItem key={quote} className="premium-card" data-testid={`pain-point-${index}`}>
              <span className="quote-mark" aria-hidden="true">"</span>
              <p className="body-regular mt-2" style={{ color: 'var(--brand-charcoal)' }}>
                "{quote}"
              </p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>);

};